// @flow
import { CommonMapper } from 'mappers/common';
import { ProjectMapper } from 'mappers/project';
import { ProjectActionTypes } from './actionTypes';

const getAnnouncements = (id, project_url_slug) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProjectActionTypes.ANNOUNCEMENTS.FETCH,
    payload: {},
    test: api
      .post(`projectAnnouncement.json`, { vertical_id: id, project_url_slug })
      .then(res => {
        const response = res.data.data || {};
        const announcements = response.project_announcements || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ProjectActionTypes.ANNOUNCEMENTS.SUCCESS,
          payload: ProjectMapper.mapProjectAnnouncements(
            announcements,
            mediaPath,
            id
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.ANNOUNCEMENTS.FAILURE,
          error,
        });
      }),
  });
};

const getGalleryForProject = (project_url_slug: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProjectActionTypes.GALLERY.FETCH,
    payload: {},
    test: api
      .post(`galleries.json`, {
        url_slug: project_url_slug,
        model: 'project',
      })
      .then(res => {
        const response = res.data.data || {};
        const galleryImages = response.galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);

        dispatch({
          type: ProjectActionTypes.GALLERY.SUCCESS,
          payload: CommonMapper.mapGalleryImages(galleryImages, mediaPath),
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.GALLERY.FAILURE,
          error,
        });
      }),
  });
};

const getProjects = id => (dispatch, getState, { api }) => {
  dispatch({
    type: ProjectActionTypes.PROJECTS.FETCH,
    payload: {},
    test: api
      .post(`projectList.json`, { vertical_id: id })
      .then(res => {
        const response = res.data.result.data || {};
        const projects = response.project_list || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        const mappedProjects = ProjectMapper.mapProjectBrowser(
          projects,
          mediaPath
        );
        dispatch({
          type: ProjectActionTypes.PROJECTS.SUCCESS,
          payload: mappedProjects,
        });

        const projectFilters = ProjectMapper.extractProjectFilters(
          mappedProjects.list
        );
        dispatch({
          type: ProjectActionTypes.PROJECT_FILTERS.INITIALIZE,
          payload: projectFilters,
        });
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.PROJECTS.FAILURE,
          error,
        });
      }),
  });
};

const getNeighbourhoodGuide = () => (dispatch, getState, { api }) => {
  dispatch({
    type: ProjectActionTypes.NEIGHBOURHOOD_GUIDE.FETCH,
    payload: {},
    test: api
      .post(`projectNeighbourhood.json`)
      .then(res => {
        const response = res.data.data || {};
        const neighbourhoods = response.project_neighbourhoods || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: ProjectActionTypes.NEIGHBOURHOOD_GUIDE.SUCCESS,
          payload: ProjectMapper.mapProjectNeighbourhoods(
            neighbourhoods,
            mediaPath
          ),
        });
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.NEIGHBOURHOOD_GUIDE.FAILURE,
          error,
        });
      }),
  });
};

const clearState = () => dispatch => {
  dispatch({
    type: 'PAGE_UNMOUNTED',
  });
};

const toggleProjectFilter = (type, value) => dispatch => {
  dispatch({
    type: ProjectActionTypes.PROJECT_FILTERS.TOGGLE_FILTER,
    payload: {
      type,
      value,
    },
  });
};

const clearProjectFilters = () => dispatch => {
  dispatch({
    type: ProjectActionTypes.PROJECT_FILTERS.CLEAR_FILTERS,
  });
};

const toggleNeighbourhoodFilter = value => dispatch => {
  dispatch({
    type: ProjectActionTypes.NEIGHBOURHOOD_FILTERS.TOGGLE_FILTER,
    payload: value,
  });
};

const initializeFilters = value => dispatch => {
  dispatch({
    type: ProjectActionTypes.NEIGHBOURHOOD_FILTERS.INITIALIZE_FILTER,
    payload: value,
  });
};

const getConstructionGalleryForProject = (project_url_slug: string) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProjectActionTypes.CONSTRUCTION_GALLERY.FETCH,
    payload: {},
    test: api
      .post(`getConstructionGalleries.json`, {
        url_slug: project_url_slug,
      })
      .then(res => {
        const response = res.data.data || {};
        const constructionGalleryData = response.construction_galleries || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: ProjectActionTypes.CONSTRUCTION_GALLERY.SUCCESS,
          payload: ProjectMapper.mapConsturctionGalleryData(
            constructionGalleryData,
            mediaPath
          ),
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.CONSTRUCTION_GALLERY.FAILURE,
          error,
        });
      }),
  });
};

const getCompletedProjects = verticalId => (dispatch, getState, { api }) => {
  dispatch({
    type: ProjectActionTypes.COMPLETED_PROJECTS.FETCH,
    payload: {},
    test: api
      .post(`getCompletedProjects.json`, {
        vertical_id: verticalId,
      })
      .then(res => {
        const response = res.data.data || {};
        const completedProjects = response.completed_projects || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: ProjectActionTypes.COMPLETED_PROJECTS.SUCCESS,
          payload: ProjectMapper.mapCompletedProjects(
            completedProjects,
            mediaPath,
            'completedProjects'
          ),
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.COMPLETED_PROJECTS.FAILURE,
          error,
        });
      }),
  });
};

const getProjectBrochure = project_url_slug => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: ProjectActionTypes.PROJECT_BROCHURE.FETCH,
    payload: {},
    test: api
      .post(`getProjectDetailSections.json`, { project_url_slug })
      .then(res => {
        const response = res.data.data || {};
        const project_detail_section = response.project_detail_section || [];
        const mediaPath = CommonMapper.extractMediaPath(response);
        dispatch({
          type: ProjectActionTypes.PROJECT_BROCHURE.SUCCESS,
          payload: ProjectMapper.mapCompletedProjects(
            project_detail_section,
            mediaPath,
            'ProjectBrochure'
          ),
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: ProjectActionTypes.PROJECT_BROCHURE.FAILURE,
          error,
        });
      }),
  });
};

export const ProjectActions = {
  getAnnouncements,
  getGalleryForProject,
  getProjects,
  getNeighbourhoodGuide,
  clearState,
  toggleProjectFilter,
  clearProjectFilters,
  toggleNeighbourhoodFilter,
  getConstructionGalleryForProject,
  initializeFilters,
  getCompletedProjects,
  getProjectBrochure,
};
